import React from "react"
import { FogImgWrapper } from "./fog-overlay"

export function fogTransformer(node, i, { classList, children }) {
  if (node.name === "figure" && classList.includes("with-fog")) {
    return <FogImgWrapper classList={classList}>{children}</FogImgWrapper>
  }
}
